import { useMemo } from "react"
import { useQuery } from "urql"

import { FULL_LIST_LIMIT } from "@/constants/common"
import type { ProductSourceChangeEvent } from "@/graphql/codegen/graphql"
import { GetProductSourceChangeHistoryDocument } from "@/graphql/codegen/graphql"

interface UseGetSourceChangeHistoryReturn {
  sourceChangeGroups: ProductSourceChangeEvent[]
  isFetching: boolean
  error?: Error
}

export const useGetSourceChangeHistory = (productId: number): UseGetSourceChangeHistoryReturn => {
  const [{ data, fetching, error }] = useQuery({
    query: GetProductSourceChangeHistoryDocument,
    variables: { input: { originalProductId: productId, offset: 0, limit: FULL_LIST_LIMIT } },
    pause: !productId,
  })

  const output = data?.productSourceChange.history

  const sourceChangeGroups = useMemo(
    () =>
      output?.__typename === "ProductSourceChangeHistorySuccess" ? (output?.items as ProductSourceChangeEvent[]) : [],
    [output]
  )

  return { sourceChangeGroups, isFetching: fetching, error }
}
